(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.pdf.view
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.tearsheet :as re-tearsheet]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.pdf.overview :as re-overview]
   [frontend.ui.component.lp-portal.report.body.real-estate.pdf.view.esg :as re-esg]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]))

(defn debt-financing-pages
  [report-data]
  (let [page-title (page/page-title {:fund-name  (:fund-name report-data)
                                     :page-title "Debt financing"})]
    (concat
     [(page/page
       (page/page-title
        {:fund-name (:fund-name report-data) :page-title "Debt financing" :toc-item true})
       (column/columns
        (card/card "Description"
                   (text-content/rich-content (-> report-data
                                                  :debt-financing
                                                  :description-text
                                                  :rich-content)))
        (table/dynamic-table-card "Portfolio debt key figures"
                                  (-> report-data
                                      :debt-financing
                                      :debt-key-figures)
                                  {:odd-color     (theme/color [:pdf :table :odd-color])
                                   :even-color    (theme/color [:pdf :table :even-color])
                                   :heading-color (theme/color [:pdf :table
                                                                :heading-color])})))]
     (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Debt financing"}
                                "Debt financing, €"
                                (-> report-data
                                    :debt-financing
                                    :portfolio-debt-financing)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Debt financing"}
                                "Hedging, €"
                                (-> report-data
                                    :debt-financing
                                    :hedging)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     [(page/page
       page-title
       (column/column
        (card/card "Lender by loans outstanding, M€"
                   {:svg   (chart-view/chart-svg "highcharts"
                                                 (-> report-data
                                                     :debt-financing
                                                     :lender-by-loans-outstanding
                                                     :figures))
                    :width 350}
                   (text-content/optional-footer (-> report-data
                                                     :debt-financing
                                                     :lender-by-loans-outstanding)))))]
     (when (some->> report-data
                    :debt-financing
                    :major-tenants
                    :figures
                    :data (seq))
       (table/dynamic-table-pages page-title
                                  "Major tenants"
                                  (-> report-data
                                      :debt-financing
                                      :major-tenants)
                                  {:wrap-text-after 6
                                   :odd-color       (theme/color [:pdf :table :odd-color])
                                   :even-color      (theme/color [:pdf :table :even-color])
                                   :heading-color   (theme/color [:pdf :table
                                                                  :heading-color])})) 
     (table/dynamic-table-pages page-title
                                "NAV Breakdown (IFRS), €"
                                (-> report-data
                                    :debt-financing
                                    :nav-breakdown)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     (table/dynamic-table-pages page-title
                                "NAV BREAKDOWN (INREV), €"
                                (-> report-data
                                    :debt-financing
                                    :inrev-nav)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])})
     (table/dynamic-table-pages page-title
                                "Investors, €"
                                (-> report-data
                                    :debt-financing
                                    :limited-partners)
                                {:odd-color     (theme/color [:pdf :table :odd-color])
                                 :even-color    (theme/color [:pdf :table :even-color])
                                 :heading-color (theme/color [:pdf :table
                                                              :heading-color])}))))

(defn table-page
  [page-title page-subtitle parsed-data]
  (page/page
   nil
   page-title
   (column/column
    (let [card (table/dynamic-table-card page-subtitle
                                         parsed-data
                                         {:wrap-text-after 6
                                          :odd-color       (theme/color [:pdf :table :odd-color])
                                          :even-color      (theme/color [:pdf :table :even-color])
                                          :heading-color   (theme/color [:pdf :table
                                                                         :heading-color])})
          title (first (:stack card))]
      {:stack (cons (assoc title :margin [0 15 0 0])
                    (rest (:stack card)))}))))

(defn details-and-figures-pages
  [report-data]
  (let [page-title {:fund-name  (:fund-name report-data)
                    :page-title "Details and figures"}]
    (concat [] 
            (when (some->> report-data
                           :details-and-figures
                           :current-portfolio)
              (table/dynamic-table-pages (merge page-title
                                                {:toc-item true})
                                         "Current portfolio, €"
                                         (-> report-data
                                             :details-and-figures
                                             :current-portfolio)
                                         {:odd-color     (theme/color [:pdf :table :odd-color])
                                          :even-color    (theme/color [:pdf :table :even-color])
                                          :heading-color (theme/color [:pdf :table
                                                                       :heading-color])}))
            (table/dynamic-table-pages page-title
                                       "Exited portfolio, €"
                                       (-> report-data
                                           :details-and-figures
                                           :exited-portfolio)
                                       {:odd-color     (theme/color [:pdf :table :odd-color])
                                        :even-color    (theme/color [:pdf :table :even-color])
                                        :heading-color (theme/color [:pdf :table
                                                                     :heading-color])})
            (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                        :page-title "Details and figures"}
                                       "Investment summary, €"
                                       (-> report-data
                                           :details-and-figures
                                           :investment-summary)
                                       {:full-width?    true
                                        :hidden-columns #{"IQID"}
                                        :odd-color      (theme/color [:pdf :table :odd-color])
                                        :even-color     (theme/color [:pdf :table :even-color])
                                        :heading-color  (theme/color [:pdf :table
                                                                      :heading-color])}))))

(defn financial-statements-pages
  [report-data]
  (let [page-title (page/page-title {:fund-name  (:fund-name report-data)
                                     :page-title "Financial statements"})]
    (concat (table/dynamic-table-pages {:fund-name  (:fund-name report-data)
                                        :page-title "Financial statements"
                                        :toc-item   true}
                                       "Consolidated statement of comprehensive income (IFRS), €"
                                       (-> report-data
                                           :financial-statements
                                           :group-income-statement)
                                       {:odd-color     (theme/color [:pdf :table :odd-color])
                                        :even-color    (theme/color [:pdf :table :even-color])
                                        :heading-color (theme/color [:pdf :table
                                                                     :heading-color])})
            (table/dynamic-table-pages page-title
                                       "Consolidated statement of financial position (IFRS), €"
                                       (-> report-data
                                           :financial-statements
                                           :statement-of-financial-position)
                                       {:odd-color     (theme/color [:pdf :table :odd-color])
                                        :even-color    (theme/color [:pdf :table :even-color])
                                        :heading-color (theme/color [:pdf :table
                                                                     :heading-color])})
            (table/dynamic-table-pages page-title
                                       "Consolidated statement of cash flows (IFRS), €"
                                       (-> report-data
                                           :financial-statements
                                           :cash-flow-statement)
                                       {:odd-color     (theme/color [:pdf :table :odd-color])
                                        :even-color    (theme/color [:pdf :table :even-color])
                                        :heading-color (theme/color [:pdf :table
                                                                     :heading-color])}))))

(defn nre-pages
  [report-data]
  (concat
   [(page/toc-page {:cover-image :front-page-image
                    :report-data report-data})]
   [(re-tearsheet/tearsheet-page report-data)]
   (re-overview/overview-pages report-data)
   (re-esg/esg-pages report-data)
   (details-and-figures-pages report-data)
   (debt-financing-pages report-data)
   (financial-statements-pages report-data)))
